import { capitalize } from "@ember/string";

/**
 * - Filters out undefined and empty string values to make sure we don't call capitalize(undefined)
 * - Capitalize each string to change "john" to "John"
 * - joins strings with ' ' to build the final string "John Doe"
 */
export function setupNames(names: string[]): string {
  return names
    .filter(Boolean)
    .map(e => capitalize(e))
    .join(" ");
}
